import {
  shouldValidateFormForRegistration,
  preventFieldForRegistration
} from '../../user/helpers/formHelper'

function sendAllRegistration({ state, output, services }) {
  let current = state.get('client.registrating.current')
  let registration = Object.keys(current).reduce((acc, key) => {
    if (shouldValidateFormForRegistration(key)) {
      let obj = {
        name: key,
        fields: []
      }
      Object.keys(current[key]).forEach(data => {
        if (preventFieldForRegistration.indexOf(data) === -1) {
          obj.fields.push({
            key: data,
            value: current[key][data].value
          })
        }
      })
      acc.push(obj)
    }
    return acc
  }, [])

  services.Http.post('/api/registration', registration)
    .then(output.success)
    .catch(output.error)
}

sendAllRegistration.async = true
export default sendAllRegistration



// WEBPACK FOOTER //
// ./src/modules/login/actions/sendAllRegistration.js